/**
 * @Description: 头像组件
 * @author Shi_qshan
 * @date 2022/10/26
 */
import React, {useEffect, useRef, useState} from "react";
import {Button, Empty, Input, Skeleton, Tag} from "antd";
import IconWeiXin from "../../iconfont/chatInfo/weixin";
import IconCompany from "../../iconfont/chatInfo/company";
import {RightOutlined} from "@ant-design/icons";
import PubSub from "pubsub-js";
import CloudApi from "../../../cloud/cloud_api";
import ZkModal from "../../../common/modal/zkModal";
import ZkFormItem from "../../../common/form/zkFormItem";
import AddMobileNumber from "../../../common/addMobileNumber/addMobileNumber";
import tag_empty from "../../../../images/common/customer/tag/tag_empty.png";
import Message from "../../../common/message";

const {TextArea} = Input;
/**
 *
 * @returns {JSX.Element}
 * @constructor
 * @param props
 * chatWxIdKey: chat_wxid的 key， 必传
 * insider： 内部成员，boolean，insider：1内部成员，0：不是
 * item：包含chat_wxid的对象，例如 {[chatWxIdKey]: '1234567890'}，下面会将该id 解构出来，必传
 * wxid：wxid，必传
 */
const AvatarInfo = (props) => {
    const {wxid, item, chatWxIdKey, insider} = props
    const {[chatWxIdKey]: chat_wxid} = item
    const [data, setData] = useState({
        remark: '',
        desc: '',
        tags: []
    })
    const [loading, setLoading] = useState(true)
    const [okLoading, setOkLoading] = useState(false)
    const [tagName, setTagName] = useState('')
    const [customerAllTag, setCustomerAllTag] = useState([])

    const setInfoRef = useRef(null)
    const tagRef = useRef(null)
    const addMobileNumberRef = useRef(null)

    useEffect(() => {
        getDataById()
    }, [wxid, chat_wxid])

    const getDataById = () => {
        let bodyData = {
            wxid: wxid,
            chat_wxid: chat_wxid,
        }
        CloudApi.getImChatGroupMemberInfo(bodyData, (data) => {
            setLoading(false)
            setData(data)
        }, (data) => {
            // Message.error(data.respMsg)
        })
    }

    const onChange = (e, type) => {
        let value = e.target.value
        if (type == 'tagName') {
            setTagName(value)
        }
        if (type == 'remark') {
            let obj = {...data}
            obj.remark = value
            setData(obj)
        }
        if (type == 'desc') {
            let obj = {...data}
            obj.desc = value
            setData(obj)
        }
    }

    //设置客户备注描述modal
    const setInfoModal = () => {
        setInfoRef.current.show()
    }

    //设置客户标签modal
    const setTagModal = () => {
        tagRef.current.show()
        //请求客户资料的标签
        CloudApi.getAccountPhoneFriendCorpTags('', (data) => {
            if (data.tagGroup) {
                data.tagGroup.forEach((item, index) => {
                    item.tag.forEach((el, ind) => {
                        el.flag = false
                        el.tagName = el.name
                        el.tagId = el.id
                    })
                })
                setCustomerAllTag(data.tagGroup)
            }
        }, () => {
            // Message.error('获取客户标签失败')
        })
    }

    //客户资料标签的筛选的回车事件
    const tagNameEnter = () => {
        //请求客户资料的标签
        CloudApi.getAccountPhoneFriendCorpTags(tagName, (data) => {
            if (data.tagGroup) {
                data.tagGroup.forEach((item, index) => {
                    item.tag.forEach((el, ind) => {
                        el.flag = false
                        el.tagName = el.name
                        el.tagId = el.id
                    })
                })
                setCustomerAllTag(data.tagGroup)
            }
        }, () => {
            // Message.error('获取客户标签失败')
        })
    }

    //点击客户资料的添加标签的标签
    const tagClick = (id) => {
        let newData = [...customerAllTag]
        newData.forEach((item, index) => {
            item.tag.forEach((el, ind) => {
                if (el.tagId == id) {
                    el.flag = !el.flag
                }
            })
        })
        setCustomerAllTag(newData)
    }

    //设置客户资料Api
    const setInfoApi = () => {
        setOkLoading(true)
        let bodyData = {
            wxid: wxid,
            chat_wxid: chat_wxid,
            remark: data.remark,
            desc: data.desc,
            mobile: addMobileNumberRef && addMobileNumberRef.current.getData() || []
        }
        CloudApi.getChatEditCustomerNewAdd(bodyData, () => {
            setOkLoading(false)
            setInfoRef.current.hide()
            getDataById()
        }, (error) => {
            Message.warning(error.respMsg)
            setOkLoading(false)
        })
    }

    //设置标签Api
    const setTagApi = () => {
        setOkLoading(true)
        let tagId = []
        let tag = []
        customerAllTag.forEach((item, index) => {
            item.tag.forEach((el, ind) => {
                if (el.flag) {
                    tagId.push(el.tagId)
                    tag.push(el)
                }
            })
        })
        let bodyData = {
            wxid: wxid,
            chat_wxid: chat_wxid,
            tagIds: tagId
        }
        CloudApi.getChatAddCustomerTag(bodyData, () => {
            setOkLoading(false)
            tagRef.current.hide()
            getDataById()
        }, () => {
            setOkLoading(false)
            Message.error('标签添加失败')
        })
    }

    return (
        <>
            {
                loading ?
                    <div>
                        {
                            insider ?
                                <header className={'zk-chatInfo-header-insider'}>
                                    <Skeleton.Image active style={{marginRight: '14px'}}/>
                                    <Skeleton.Button active/>
                                </header>
                                :
                                <>
                                    <header className={'zk-chatInfo-header'}>
                                        <div>
                                            <Skeleton.Avatar active shape={"circle"} style={{marginRight: '5px'}}/>
                                            <Skeleton.Button active/>
                                        </div>
                                        <Skeleton.Image active/>
                                    </header>
                                    <Skeleton paragraph={{rows: 1}} title={''} active/>
                                </>
                        }

                        {/*分割线*/}
                        <div className={'zk-chatInfo-line'}></div>
                        {
                            insider ? '' :
                                <Skeleton paragraph={{rows: 2}} title={''} active/>
                        }

                        {
                            insider ?
                                <Skeleton paragraph={{rows: 1, width: ['100%']}} title={''} active/>
                                :
                                <>
                                    {/*分割线*/}
                                    <div className={'zk-chatInfo-line'}></div>
                                    <Skeleton paragraph={{rows: 3, width: ['50%', '70%', '100%']}} title={''} active/>
                                </>
                        }
                    </div>
                    :
                    <div>
                        {
                            insider ?
                                <header className={'zk-chatInfo-header-insider'}>
                                    <img src={data.avatar} className={'zk-chatInfo-avatar'}
                                         style={{marginRight: '14px'}}/>
                                    <div className={'zk-chatInfo-name'} style={{margin: '0'}}>{data.nickname}</div>
                                </header>
                                :
                                <header className={'zk-chatInfo-header'}>
                                    <div>
                                        {
                                            data.corpShortName == '微信' ?
                                                <>
                                                    <IconWeiXin
                                                        style={{width: '16px', height: '13px', marginRight: '5px'}}/>
                                                    {'微信'}
                                                </>
                                                :
                                                <>
                                                    <IconCompany
                                                        style={{width: '14px', height: '12px', marginRight: '5px'}}/>
                                                    {data.corpShortName || '企业微信用户'}
                                                </>
                                        }
                                    </div>
                                    <img src={data.avatar} className={'zk-chatInfo-avatar'}/>
                                </header>
                        }
                        {
                            insider ? ''
                                :
                                <>
                                    {
                                        data.remark ? <div className={'zk-chatInfo-name'}>{data.remark}</div> : ''
                                    }
                                    <div className={'zk-chatInfo-name-s2'}>微信昵称：{data.nickname}</div>
                                </>
                        }

                        {/*分割线*/}
                        <div className={'zk-chatInfo-line'}></div>

                        {
                            insider ? ''
                                :
                                <>
                                    {/*设置备注标签*/}
                                    {
                                        data.isFriend == 1 ?
                                            <>
                                                <div className={'zk-chatInfo-item'} onClick={setInfoModal}>
                                        <span
                                            className={'item-title-s1'}>{data.desc || data.remark ? '描述' : '设置备注和描述'}</span>
                                                    {
                                                        data.remark ?
                                                            <div className={'item-remark-value'}>{data.desc}</div> : ''
                                                    }
                                                    <RightOutlined style={{fontSize: '12px', color: '#6C7076'}}/>
                                                </div>

                                                <div className={'zk-chatInfo-item'} onClick={setTagModal}>
                                        <span
                                            className={'item-title-s1'}>{data.tags && data.tags.length ? '标签' : '设置标签'}</span>
                                                    {
                                                        data.tags && data.tags.length ?
                                                            <div className={'item-tag-value'}>
                                                                {data.tags.map(obj => <Tag
                                                                    key={obj.tagId}>{obj.tagName}</Tag>)}
                                                            </div> : ''
                                                    }
                                                    <RightOutlined style={{fontSize: '12px', color: '#6C7076'}}/>
                                                </div>
                                            </> : ''
                                    }

                                    {/*添加时间 来源*/}
                                    {
                                        data.isFriend == 1 ?
                                            <>
                                                <div className={'zk-chatInfo-line'}></div>
                                                <div className={'zk-chatInfo-item-s2'}>
                                                    <span className={'item-title-s1'}>添加时间</span>
                                                    <span
                                                        className={'item-title-s2'}>{data.addTime ? new Date(data.addTime).format('yyyy-MM-dd hh:mm') : ''}</span>
                                                </div>
                                                <div className={'zk-chatInfo-item-s2'}>
                                                    <span className={'item-title-s1'}>来源</span>
                                                    <span className={'item-title-s2'}>{data.from}</span>
                                                </div>
                                            </> : ''
                                    }
                                </>
                        }

                        {
                            data.isFriend == 1 ?
                                <Button type={'primary'} className={'zk-chatInfo-btn'} onClick={() => {
                                    PubSub.publish('IM_CHAT_SEND_MESSAGE', {chat_wxid: chat_wxid});
                                }}>
                                    {'发消息'}
                                </Button>
                                :
                                <Button type={'primary'} className={'zk-chatInfo-btn'}
                                        onClick={() => {
                                            // addFriend(item)
                                            PubSub.publish('IM_CHAT_ADD_FRIEND', {senderId: chat_wxid});
                                        }}>
                                    {'添加为联系人'}
                                </Button>
                        }
                    </div>
            }

            <ZkModal
                ref={setInfoRef}
                title={'客户资料'}
                width={520} maskClosable={false}
                className={'modal-right-btn'}
                footer={[
                    <Button key="back" onClick={() => setInfoRef.current.hide()}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" loading={okLoading}
                            onClick={setInfoApi}>
                        确定
                    </Button>,
                ]}
            >
                <ZkFormItem title={'备注'} colon={true} titleWidth={'56px'} conWidth={'370px'}>
                    <div className={'task_name customer_remark'}>
                        <Input placeholder={'请输入备注信息'} maxLength={20} value={data.remark}
                               onChange={e => onChange(e, 'remark')}/>
                        <span
                            className='word-limit'>{data.remark ? data.remark.length + '/20' : '0/20'}</span>
                    </div>
                </ZkFormItem>
                <ZkFormItem title={'描述'} colon={true} titleWidth={'56px'} conWidth={'370px'}>
                    <div className={'task_name customer_desc'}>
                        <TextArea autoSize={{minRows: 7, maxRows: 7}} placeholder={'请输入描述信息'} value={data.desc}
                                  onChange={e => onChange(e, 'desc')} maxLength={150}/>
                        <span
                            className='word-limit'>{data.desc ? data.desc.length + '/150' : '0/150'}</span>
                    </div>
                </ZkFormItem>
                <AddMobileNumber ref={addMobileNumberRef} title={'手机号'} mobile={data.mobile}/>
            </ZkModal>

            <ZkModal
                title={'选择标签'} className={'modal-right-btn'}
                ref={tagRef} width={'660px'}
                destroyOnClose maskClosable={false}
                footer={[
                    <Button key="back" onClick={() => tagRef.current.hide()}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" loading={okLoading}
                            onClick={setTagApi}>
                        确定
                    </Button>,
                ]}
            >
                <div style={{height: '400px'}}>
                    <Input placeholder={'请输入标签'} value={tagName} onChange={e => onChange(e, 'tagName')}
                           onPressEnter={tagNameEnter}/>
                    <div className={'tags_inModal_content'} style={{marginTop: '10px', height: '350px'}}>
                        {
                            customerAllTag ?
                                <>
                                    {
                                        customerAllTag.map((item, index) => {
                                            return <div key={index}>
                                                <div
                                                    className={index > 0 ? 'send_groupName' : ''}>{item.groupName}：
                                                </div>
                                                <div className={'label_array'}>
                                                    {
                                                        item.tag && item.tag.map((el, ind) => {
                                                            return <span key={el.tagId}
                                                                         className={el.flag ? 'pitch_on' : 'unselected'}
                                                                         onClick={tagClick.bind(this, el.tagId)}
                                                            >
                                                            {el.tagName}
                                                        </span>
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        })
                                    }
                                </>
                                :
                                <div style={{marginTop: '12px', fontWeight: '600'}}>
                                    <Empty image={tag_empty} description={'没有搜到相关客户标签哦~'}/>
                                </div>
                        }
                    </div>
                </div>
            </ZkModal>
        </>
    )
}

export default AvatarInfo